import script from "./IncomeSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeSummary.vue?vue&type=script&setup=true&lang=js"

import "./IncomeSummary.vue?vue&type=style&index=0&id=39ddf646&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ddf646"]])

export default __exports__